module.exports = __webpack_public_path__ + "static/media/icon_mission_email.f7048c56.svg";